<div class="modal-backdrop" (click)="closeModal.emit()"></div>
<div class="modal-content">
  <div class="modal-header">
    <h2>Invite New Member</h2>
    <button class="close-btn" (click)="closeModal.emit()">&times;</button>
  </div>
  <div class="modal-body">
    <form [formGroup]="inviteForm" (ngSubmit)="onInvite()">
      <div class="form-block">
        <label for="firstName">First Name</label>
        <input id="firstName" type="text" formControlName="firstName">
      </div>
      <div class="form-block">
        <label for="lastName">Last Name</label>
        <input id="lastName" type="text" formControlName="lastName">
      </div>
      <div class="form-block">
        <label for="email">Email</label>
        <input id="email" type="email" formControlName="email">
      </div>
      <div *ngIf="firstName?.value" class="invitation-message">
        <p>{{ firstName?.value }} will receive an email invitation from you when you click submit.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal.emit()">Cancel</button>
        <button type="submit" class="btn btn-primary" [disabled]="!inviteForm.valid">Submit</button>
      </div>
    </form>
  </div>
</div>
